import { action, computed, makeObservable, observable } from 'mobx';

import { ProviderUid } from '@gem/call/CallProviders/callProviders.types';
import { MemberDevice } from '@gem/call/CallStore/Member/MemberDevice';
import { ClientRole } from '@gem/call/constants';

import { Call } from '../Call';

export interface IOpponentConstructorParams {
  call: Call;
  sortIndex: number;
  role: ClientRole;
  uid: ProviderUid;
  hasAudio: boolean;
  hasVideo: boolean;
}

export class Opponent {
  uid: ProviderUid;
  call: Call;
  // ToDo: [CALLS-B2B] -  подумать над выпиливанием роли и изменением логики для синхронизации ухода юзера из звонка и евентом с SSE
  @observable role: ClientRole = ClientRole.Audience;
  @observable sortIndex = 0;
  @observable isPlayingVideo = false;
  @observable hasAudio = false;
  @observable hasVideo = false;
  @observable volumeLevel = 0;
  hasLeft = false;

  constructor({ call, hasAudio, hasVideo, sortIndex, role, uid }: IOpponentConstructorParams) {
    makeObservable(this);
    // ToDo: [CALLS-B2B] - выпилить call и перенести member и isSharedScreen в отдельный селектор
    this.call = call;
    this.uid = uid;
    this.sortIndex = sortIndex;
    this.role = role;
    this.hasVideo = hasVideo;
    this.hasAudio = hasAudio;
  }

  get isMe(): boolean {
    return false;
  }
  // ToDO: [CALLS-B2B] передавать сылку на мембера вместо самого кола
  get memberDevice(): MemberDevice | null {
    const memberDevice = this.call.members.getMemberDeviceByUid(this.uid);

    if (memberDevice) {
      return memberDevice;
    }

    return (
      this.call.members.memberDevicesList.find((memberDevice) => {
        return memberDevice.shareScreenUid === this.uid;
      }) || null
    );
  }

  get handRaisedPosition(): number | null {
    if (this.call.members.handsQueue.isShowPosition) {
      return this.call.members.handsQueue.getPosition(this.uid);
    }

    return null;
  }

  @action
  setVolumeLevel(level: number): void {
    this.volumeLevel = level;
  }

  @action
  setIsPlayingVideo(isPlayingVideo: boolean): void {
    this.isPlayingVideo = isPlayingVideo;
  }

  @action
  setHasAudio(hasAudio: boolean): void {
    this.hasAudio = hasAudio;
  }

  @action
  setHasVideo(hasVideo: boolean): void {
    this.hasVideo = hasVideo;
  }

  @action
  setSortIndex(sortIndex: number): void {
    this.sortIndex = sortIndex;
  }

  @action
  setRole(role: ClientRole): void {
    this.role = role;
  }

  @computed
  get isActiveSpeaker(): boolean {
    return this.volumeLevel > 1 && this.hasAudio;
  }

  @computed
  get isSharedScreen(): boolean {
    if (!this.memberDevice) {
      return false;
    }

    return this.memberDevice.shareScreenUid === this.uid;
  }
}
